
<div class="cm-hero-container">
	<video #heroVideo loop="" autoplay="" muted="true" playsinline="" class="el-image"
		uk-cover="">
		<source src="/assets/images/croptrailer.mp4" type="video/mp4">
		Your browser does not support the video tag.
	</video>
	<div class="cm-hero-container__overlay"></div>
	<div class="cm-hero-container__text">
		<h1>Efficient Farming, Backed by Science</h1>
		<p>
			Developed through University of California research in collaboration
			with growers, CropManage helps you apply the right amount of water
			and nitrogen to optimize yield and quality, while cutting costs,
			reducing waste, and protecting the environment.
		</p>
		<button class="cm-button--hero-cta" routerLink="/register">
			Get started
			<!-- <mat-icon>arrow_right_alt</mat-icon> -->
		</button>
	</div>
</div>

<div class="cm-affiliated-with-section">
	<h2 class="cm-uppercase-heading">Affiliated with</h2>
	<div class="cm-affiliated-with-section__icons">
		<img src="../assets/images/logos/landing-page/casp-logo.webp"/>
		<img src="../assets/images/logos/landing-page/dwr-logo.webp"/>
		<img src="../assets/images/logos/landing-page/cdfa-logo.webp"/>
		<img src="../assets/images/logos/landing-page/frep-logo.webp"/>
		<img src="../assets/images/logos/landing-page/nasa-logo.webp"/>
		<img src="../assets/images/logos/landing-page/ssjvmpep-logo.webp"/>
		<img src="../assets/images/logos/landing-page/ucanr-logo.webp"/>
	</div>
	<hr>
</div>

<div class="cm-landing-fixed-width cm-decision-support-section">
	<h2 class="cm-dark-heading">
		Decision Support Build for the Field.
	</h2>
	<p class="cm-basic-text">
		CropManage is a free online decision-support tool for irrigation and
		nutrient management.  It uses weather, soil, and crop data to deliver
		precise irrigation and nitrogen fertilizer recommendations.
	</p>
	<div class="cm-benefits-list">
		<div class="cm-benefits-list__item">
			<div class="cm-benefits-list__item__icon">
				<svg-research-backed></svg-research-backed>
			</div>

			<h3>Research backed, field ready</h3>
			<p>
				Grounded in science and proven in over 30 field trials,
				CropManage gives you confidence to make critical decisions in
				the field.
			</p>
		</div>
		<div class="cm-benefits-list__item">
			<div class="cm-benefits-list__item__icon">
				<svg-do-more-with-less></svg-do-more-with-less>
			</div>

			<h3>Do more with less</h3>
			<p>
				CropManage helps you apply the right amount of water and
				nitrogen—cutting costs and avoiding over-application without
				sacrificing crop performance.
			</p>
		</div>
		<div class="cm-benefits-list__item">
			<div class="cm-benefits-list__item__icon">
				<svg-no-hardware-required></svg-no-hardware-required>
			</div>

			<h3>No hardware required</h3>
			<p>
				CropManage delivers accurate results without soil sensors,
				flow meters, or other monitoring devices. No installation or
				maintenance required.
			</p>
		</div>
		<div class="cm-benefits-list__item">
			<div class="cm-benefits-list__item__icon">
				<svg-access-anywhere></svg-access-anywhere>
			</div>
			<h3>Access anywhere</h3>
			<p>
				CropManage runs in your browser on any device—smartphone,
				tablet, laptop, or desktop—so your data is always within
				reach, anywhere you work.
			</p>
		</div>
	</div>
	<button class="cm-button--get-notified"
		routerLink="/getting-started">
		Learn More
		<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
	</button>
</div>

<div class="cm-features-section">
	<div class="cm-landing-fixed-width">
		<h2 class="cm-dark-heading">
			Powerful, easy-to-use tools for managing your crops
		</h2>
		<mat-tab-group class="cm-landing-mat-tab">
			<mat-tab label="Irrigation">
				<div class="cm-tab-content__left">
					<h3 class="cm-underlined">
						Precise Irrigation Scheduling
					</h3>
					<p><strong>Know exactly how much to irrigate and when.</strong>
						CropManage tracks soil water over time and recommends
						how long to irrigate based on your crop, weather, and soil.
					</p>
					<ul>
						<li><span><strong>Deficit irrigation scheduling</strong> - 
							CropManage adjusts recommendations based on your
							target crop ET percentage, helping you conserve water
							during drought without compromising yield.</span></li>
						<li><span><strong>Soil water balance tracking</strong> - 
							CropManage tracks how much water is in your soil over time,
							to help you decide when it's the right time to irrigate.</span></li>
					</ul>
				</div>
				<img src="../assets/images/illustrations/screencap-irrigation-event.png"
					width="657" height="474"/>
			</mat-tab>
			<mat-tab label="Fertilization">
				<div class="cm-tab-content__left">
					<h3 class="cm-underlined">
						Smart Nitrogen Management
					</h3>
					<p>Apply just the right amount of nitrogen with
						recommendations grounded in extensive field trials.
					</p>
					<ul>
						<li><span><strong>Account for nitrogen in your irrigation water</strong>
							to avoid waste and reduce costs.</span></li>
						<li><span><strong>Incorporate nitrogen measurements from soil samples</strong>
							to fine-tune recommendations throughout the season.</span></li>
						<li><span><strong>Use field-tested crop nitrogen uptake curves</strong>
							to predict needs accurately</span></li>
						<li><span><strong>Factor in nitrogen from mineralization</strong>
							of crop residues, manure, compost, and cover crops.</span></li>
					</ul>
				</div>
				<img src="../assets/images/illustrations/n contribution.png"
					width="657" height="474"/>
			</mat-tab>
			<mat-tab label="Record Keeping">
				<div class="cm-tab-content__left">
					<h3 class="cm-underlined">
						Record Keeping & Compliance
					</h3>
					<p>Keep accurate, organized records of every field activity
						to support better decisions and meet compliance requirements.
					</p>
					<ul>
						<li><span><strong>Spot problems at a glance</strong> by comparing
							actual vs recommended water and nitrogen use.</span></li>
						<li><span><strong>Estimate total seasonal crop ET</strong>
							with the built-in calculator for use in irrigation
							compliance reports.</span></li>
						<li><span><strong>Stay compliance-ready</strong> with
							accurate, organized records of water and nutrient
							applications</span></li>
						<li><span><strong>Export seasonal summaries</strong>
							of water and nitrogen use to Excel for reporting,
							sharing, or in-depth analysis.</span></li>
					</ul>
				</div>
				<img src="../assets/images/illustrations/event records.png"
					width="657" height="474"/>
			</mat-tab>
			<mat-tab label="Sensors">
				<div class="cm-tab-content__left">
					<h3 class="cm-underlined">
						Sensors & Flow Meter Integration
					</h3>
					<p>Connect soil sensors and flow meters to bring real-time
						field data into CropManage, helping you monitor water
						use, track soil conditions, and align irrigation
						decisions with actual field conditions.
					</p>
					<ul>
						<li>
							<span>
								<strong>Spot operational problems quickly</strong>
								with real-time data from connected sensors.
							</span>
						</li>
						<li><span><strong>See trends instantly</strong> with charts
							of soil moisture and water use from connected
							sensors and flow meters.</span></li>
						<li><span><strong>Reduce manual data entry</strong> with flow
							meter integration that automatically records
							irrigation events.</span></li>
						<li><span><strong>Compare real-world conditions to
							recommendations</strong> by reviewing sensor and
							flow meter charts alongside CropManage irrigation
							guidance.</span></li>
					</ul>
				</div>
				<img src="../assets/images/illustrations/flowmeter.png"
					width="657" height="474"/>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>

<div class="cm-landing-fixed-width cm-availability-section">
	<h2 class="cm-dark-heading">
		Where is CropManage Available?
	</h2>
	<div class="cm-flex-content">
		<div class="cm-tab-content__left">
			<h4 class="mt-0">Current Coverage:</h4>
			<ul>
				<li>
					<strong>Irrigation recommendations</strong> are currently
					available in <strong>California, Arizona, Hawaii,</strong>
					and <strong>Guam.</strong>
				</li>
				<li>
					<strong>Fertilizer planning tools</strong> are available
					nationwide.
				</li>
			</ul>
			<h4>
				Interested in Using CropManage in Your Area?
			</h4>
			<p>
				We're working to expand support as more regional weather
				data becomes available. Get notified when CropManage becomes
				available in your area.
			</p>
			<button class="cm-button--get-notified"
				routerLink="/contact-us">
				Get Notified
				<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
			</button>
		</div>
		<img src="../assets/images/illustrations/us-modified v2.svg"
			width="648" height="494"/>
	</div>
</div>

<!-- crop types -->
<div class="cm-crop-types-section">
	<div class="cm-landing-fixed-width">
		<h2 class="cm-dark-heading">
			What Crops are Supported?
		</h2>
		<div class="cm-flex-content">
			<img src="../assets/images/illustrations/crop-grid.png"
				width="640" height="442"/>
			<div class="cm-tab-content__left">
				<p class="mt-0 mb-24">
					CropManage supports <strong>over 40 crop types</strong>
					for irrigation and nutrient planning — from leafy greens
					to tree crops. Examples include:
				</p>
				<p class="mt-0 mb-24">
					<strong>Vegetables/Row Crops:</strong> tomato, lettuce, 
					spinach, pepper, onion, cabbage, broccoli, eggplant, squash
				</p>
				<p class="mt-0 mb-24">
					<strong>Fruits & Orchard Crops:</strong> grape, citrus,
					almond, strawberry, walnut, pistachio, pear, prune,
					watermelon
				</p>
				<p class="mt-0 mb-0">
					<strong>Agronomic Crops:</strong> alfalfa, corn
				</p>
				<div class="cm-button-pair">
					<button class="cm-view-full-list-button"
						routerLink="/crop-types-available">
						View Full List
						<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
					</button>

					<button class="cm-request-crop-button"
						routerLink="/contact-us">
						Request a Crop
						<mat-icon class="material-symbols-outlined">keyboard_arrow_right</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- testimonials -->
<div class="cm-landing-fixed-width cm-testimonials-section">
	<div class="cm-tab-content__left">
		<div class="cm-tab-content__left__left">
			<h2 class="cm-dark-heading mb-24">
				Trusted by growers. Proven in the field.
			</h2>
			<p>
				Irrigation and nutrient decisions can make or break a season.
				We built CropManage in collaboration with growers to deliver
				clear guidance when it matters most.
			</p>
		</div>
		<div class="cm_testimonials-section__credentials">
			<div class="cm_testimonials-section__credential-item">
				<img src="../assets/images/icons/landing-page/credentials/irrigation.svg"
					width="60" height="60"/>
				<div>
					<h3>27% less</h3>
					<h4>water used</h4>
					<p class="w-150">
						in broccoli trials, with no yield loss
					</p>
				</div>
			</div>
			<div class="cm_testimonials-section__credential-item">
				<img src="../assets/images/icons/landing-page/credentials/nutrition.svg"
					width="60" height="60"/>
				<div>
					<h3>Up to 31% </h3>
					<h4>less nitrogen</h4>
					<p class="w-150">
						in lettuce, with yields 7% higher than grower standard
					</p>
				</div>
			</div>
			<div class="cm_testimonials-section__credential-item">
				<img src="../assets/images/icons/landing-page/credentials/calendar.svg"
					width="60" height="60"/>
				<div>
					<h3>10+ years</h3>
					<h4>in the field</h4>
					<p class="w-150">
						tested and refined in real-world operations
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="cm-testimonials-section__testimonials">
		<div class="cm-testimonials-section__testimonials__item">
			<img src="../assets/images/photos/mark-mason.webp"
				width="204" height="182"/>
			<div>
				<p>
					“CropManage reduces your inputs. The
					models work and you have reporting tools for water and
					nitrogen in a nice format for regulatory reporting. At
					first I used it on 10 acres, then 100 acres, and now our
					head lettuce and leaf lettuce programs use CropManage.”
				</p>
				<div class="cm-testimonial__attribution">
					Mark Mason, Huntington Farms
				</div>
			</div>
		</div>
		<div class="cm-testimonials-section__testimonials__item">
			<img src="../assets/images/photos/hortenda.webp"
				width="204" height="182"/>
			<div>
				<p>
					“CropManage is great because it does
					all the calculations
					for you, saving time. It also does all the tracking for
					you – you can go to a specific date to look at irrigation
					events to review what has been applied. It’s a time saver
					when you are scheduling other activities on the ranch.”
				</p>
				<div class="cm-testimonial__attribution">
					Hortencia Alvarado, The Wine Group
				</div>
			</div>
		</div>
	</div>
</div>

<!-- CTA -->
<div class="cm-call-to-action-section">
	<h2 class="cm-dark-heading">
		Grow smarter. Waste less. Harvest more.
	</h2>
	<button class="cm-get-started-button"
		routerLink="/register">
		Get Started
		<mat-icon class="material-symbols-outlined">arrow_right_alt</mat-icon>
	</button>
</div>